import {
  Button,
  Divider,
  Form,
  Input,
  InputNumber,
  message,
  Modal
} from "antd";
import { SidepanelStyles } from "constants/index";
import { ProjectContext } from "context/ProjectProvider";
import { useContext, useEffect, useState } from "react";
import { CreateMaterialFromSubmittalAPI } from "../auth/extraction-auth";

export default function CreateExtractMaterialFromSubmittal({
  openDrawer,
  onCancel,
  onComplete,
  selectedRows
}: {
  openDrawer: boolean;
  onCancel: () => void;
  onComplete: () => void;
  selectedRows: any[];
}) {
  const { projectDetails, tokenRetrievalState } = useContext(ProjectContext);
  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();
  useEffect(() => {
    if (openDrawer && selectedRows?.length > 0) {
      form.setFieldsValue({
        submittals: selectedRows.map((row) => {
          const sequenceId = row.sequence_id || "";
          const cellText =
            projectDetails?.spec_section && row.spec_section.length > 0
              ? `${row.spec_section[0].number} - ${row?.sequence_id}`
              : `${sequenceId}`;

          return {
            name: `${cellText} - ${row.title}`,
            submittalId: row.id,
            materials: [{ name: `${row.title?.substring(0, 10)} Mat` }]
          };
        })
      });
    }
  }, [openDrawer, selectedRows, form, projectDetails?.spec_section]);

  return (
    <Modal
      className="custom-drawer"
      title={[
        <div data-testid="extract-material-from-submittal-modal">
          <span>Create Material</span>
          <span className="text-xs font-normal ml-2 mr-2">|</span>
          <span className="text-xs font-normal">
            {selectedRows.length === 1
              ? "1 Submittal Selected"
              : `${selectedRows.length} Submittals Selected`}
          </span>
        </div>
      ]}
      width={740}
      style={SidepanelStyles.style}
      footer={[
        <section className="submittal-modal-footer " key={100}>
          <Button onClick={onCancel} disabled={loading}>
            Cancel
          </Button>
          <Button
            htmlType="submit"
            type="primary"
            disabled={loading}
            loading={loading}
            onClick={async () => {
              setLoading(true);
              try {
                const values = form.getFieldsValue();
                console.log(form.getFieldsValue());

                const output = {
                  materials: values.submittals.flatMap((sub: any) =>
                    sub.materials.map(
                      (material: any, materialIndex: number) => ({
                        linked_submittal_id: sub.submittalId,
                        title: material.name, // or custom title logic
                        tag_name: `Tag${materialIndex + 1}` // auto tag
                      })
                    )
                  )
                };

                const res = await CreateMaterialFromSubmittalAPI(
                  output,
                  tokenRetrievalState?.token
                );
                message.success(
                  res.data.message ||
                    "Materials successfully created from submittals."
                );
                onComplete();
              } catch (err) {
                console.error(err);
              }
              setLoading(false);
            }}
          >
            Confirm
          </Button>
        </section>
      ]}
      open={openDrawer}
      onCancel={() => {
        onCancel();
      }}
      destroyOnClose
      data-testid="index-modal-extract-material-single"
    >
      <div className="flex flex-col">
        <Form form={form} layout="vertical" className="">
          <div className="w-full flex text-xs font-bold text-black text-opacity-60">
            <div className="w-1/2">Submittals</div>
            <div className="w-1/2 flex">
              <div className="grow"> Material Created</div>
              {selectedRows?.length === 1 && (
                <div className="w-24">No. of Materials</div>
              )}
            </div>
          </div>

          <Form.List name="submittals">
            {(submittalFields) => (
              <>
                {submittalFields.map((submittalField) => (
                  <>
                    <Divider className="w-full my-3" />
                    <div
                      key={submittalField.key}
                      className="w-full flex text-black text-opacity-90"
                    >
                      <div className="w-1/2">
                        <Form.Item
                          name={[submittalField.name, "name"]}
                          className=""
                        >
                          <div className="text-gray-700">
                            {form.getFieldValue([
                              "submittals",
                              submittalField.name,
                              "name"
                            ])}
                          </div>
                        </Form.Item>
                      </div>
                      <div className="w-1/2">
                        <Form.List name={[submittalField.name, "materials"]}>
                          {(materialFields, { add, remove }) => (
                            <div className="flex space-x-1">
                              <div className="space-y-2 grow">
                                {materialFields.map((materialField) => (
                                  <Form.Item
                                    key={materialField.key}
                                    name={[materialField.name, "name"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Material required"
                                      }
                                    ]}
                                  >
                                    <Input />
                                  </Form.Item>
                                ))}
                              </div>
                              {/* Counter */}
                              {selectedRows?.length === 1 && (
                                <div className="">
                                  <InputNumber
                                    min={1}
                                    className="w-24"
                                    value={materialFields.length}
                                    controls
                                    onChange={(value) => {
                                      if (!value) return;

                                      const firstMatName = form.getFieldValue([
                                        "submittals",
                                        submittalField.name,
                                        "materials",
                                        materialFields[0].name,
                                        "name"
                                      ]);

                                      const diff =
                                        value - materialFields.length;

                                      if (diff > 0) {
                                        for (let i = 0; i < diff; i = 1 + i) {
                                          add({
                                            name: `${firstMatName} ${
                                              materialFields.length + i + 1
                                            }`
                                          });
                                        }
                                      } else {
                                        for (
                                          let i = materialFields.length;
                                          i > value;
                                          i = -1 + i
                                        ) {
                                          remove(i - 1);
                                        }
                                      }
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                          )}
                        </Form.List>
                      </div>
                    </div>
                  </>
                ))}
              </>
            )}
          </Form.List>
        </Form>
      </div>
    </Modal>
  );
}
